// extracted by mini-css-extract-plugin
module.exports = {"table":"actions-history-modal_table__1-vGw","container":"actions-history-modal_container__2DqGZ","modal":"actions-history-modal_modal__2arbK"};